<template>
  <div class>
    <div
      slot="header"
      class="clearfix"
      style="background-color: #f2f2f2; padding: 20px"
    >
      <span style="font-weight: 600; color: #000; line-height: 10px"
        >告警通知组信息</span
      >
    </div>
    <div class>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="120px"
        style="width: 600px; margin-top: 30px"
      >
        <el-form-item label="告警通知组名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入告警通知组名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="通知号码" prop="mobiles">
          <el-input
            type="textarea"
            v-model="form.mobiles"
            placeholder="请填写手机号码，如13888888888，13666666666"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="clearfix"
      style="background-color: #f2f2f2; padding: 20px; margin-top: 40px"
    >
      <span style="font-weight: 600; color: #000; line-height: 10px"
        >设备信息</span
      >
    </div>
    <div class>
      <el-form
        :model="form2"
        :rules="rules2"
        ref="form"
        label-width="120px"
        style="width: 600px; margin-top: 30px"
      >
        <el-form-item label="选择设备" style="width: 500px" prop="deviceIDs">
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText1"
          >
          </el-input>
          <el-tree
            class="filter-tree"
            :data="datatree1"
            show-checkbox
            :props="defaultProps"
            default-expand-all
            :filter-node-method="filterNode1"
            @check-change="handleCheckChange"
            ref="tree1"
          >
          </el-tree>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="btns"
      style="
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <el-button @click="cancel" class="resetbtn">取消</el-button>
      <el-button type="success" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request.js";

//import x from ''
export default {
  name: "tongzhiguanli",
  components: {},
  data() {
    return {
      form: {
        name: "",
        mobiles: "",
      },
      form2: {
        deviceIDs: "",
      },
      filterText1:"",
      agreementOption: [],
      datatree1: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      selectedDevice:[],
      rules: {
        name: [{ required: true, message: "请输入告警通知组名称", trigger: "blur" }],
        mobiles: [{ required: true, message: "请填写手机号码，如13888888888，13666666666", trigger: "blur" }],
      },
      rules2: {
        deviceIDs: [
          { required: true, message: "请选择设备", trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  watch: {
    filterText1(val) {
      this.$refs.tree1.filter(val);
    }
  },
  methods: {
    cancel() {
      this.form = {
        remark: "",
      };
    },
    filterNode1(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    save() {
      let projectDeviceIds = this.$refs.tree1.getCheckedNodes()
      let tmpDeviceIds = [];
      projectDeviceIds.forEach(element => {
        if(element.parentId != '') {
          tmpDeviceIds.push(element.id)
        }
      });
      let data = {
        name: this.form.name,
        mobiles: this.form.mobiles,
        deviceIDs: tmpDeviceIds.join(',')
      };
      this.$store.dispatch("form/handle", {
        url: "/battery/dcNoticeGroup/put",
        data: data,
        method: "put",
        callback: (resp) => {
          this.$router.go(-1);
        },
      });
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
    },
    handleNodeClick(data) {
      console.log(data);
    },
  },
  mounted() {},
  created() {},
  beforeCreate() {
    this.$store.dispatch("form/handle", {
      url: "/battery/tree/projectDevice",
      data: {},
      method: "get",
      callback: (resp) => {
        this.datatree1 = resp;
      },
    });
  }, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.btn {
  width: 600px;
  height: 50px;
  margin-top: 10px;
  margin-left: 40%;
}
.resetbtn:hover {
  border: 1px solid #00cc00; 
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00; 
  color: #ffffff;
  background-color:#00cc00;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/notifiGroupManagement/addNotifiGroup.vue